function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.838C1 2.823 1.86 2 2.922 2h10.156C14.139 2 15 2.823 15 3.838v2.775c0 .553-.256 1.05-.661 1.387.405.337.661.834.661 1.387v2.775C15 13.177 14.14 14 13.078 14H2.922C1.861 14 1 13.177 1 12.162V9.387c0-.553.256-1.05.661-1.387A1.801 1.801 0 011 6.613V3.838zm1.922 4.613c-.54 0-.979.42-.979.936v2.775c0 .517.438.936.98.936h10.155c.54 0 .979-.419.979-.936V9.387c0-.517-.438-.936-.98-.936H2.923zm10.156-.902c.54 0 .979-.42.979-.936V3.838c0-.517-.438-.936-.98-.936H2.923c-.54 0-.979.419-.979.936v2.775c0 .517.438.936.98.936h10.155zm-1.923-2.324c0-.249.212-.45.472-.45h.007c.26 0 .472.201.472.45 0 .25-.211.451-.472.451h-.007a.462.462 0 01-.472-.45zm0 5.55c0-.25.212-.451.472-.451h.007c.26 0 .472.202.472.45 0 .25-.211.451-.472.451h-.007a.461.461 0 01-.472-.45z",
  fill: "#2D2D2D"
});
function SvgServidor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Servidor.svg";
export { SvgServidor as ReactComponent };